import Vue from 'vue'
import VueRouter from 'vue-router'
import Comprar from '../components/Comprar.vue'
import Admin from '../components/Admin.vue'
import StatusPedido from '../components/StatusPedido.vue'
import AvaliarPedido from '../components/AvaliarPedido.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Comprar
    },
    {
        path: '/admin',
        name: 'Admin',
        component: Admin
    },
    {
        path: '/avaliar',
        name: 'Avaliar',
        component: AvaliarPedido
    },
    // Mapear as rotas de retorno do Mercado Pago para o mesmo componente
    { path: '/success', component: StatusPedido },
    { path: '/failure', component: StatusPedido },
    { path: '/pending', component: StatusPedido },
    // Rota genérica para status se necessário
    { path: '/status', component: StatusPedido }
]

const router = new VueRouter({
    // Use 'hash' para manter compatibilidade com URLs com # (ex: localhost:8080/#/admin)
    // Se mudar para 'history', precisará configurar o servidor (backend) para redirecionar.
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router